<template>
  <UserList v-bind="$props" />
</template>

<script>
import UserList from '@/components/UserList';

export default {
  name: 'UsersTab',

  components: {
    UserList,
  },

  props: [
    /* eslint-disable vue/prop-name-casing, vue/require-prop-types */
    'distributor_id',
    'subdistributor_id',
    'chain_id',
    'store_id',
  ],
};
</script>
